export const PROGRAM_COLUMN_WIDTH = '40%';
